@if (quoteRequestForm !== undefined) {
  <form [formGroup]="quoteRequestForm.controls.bondLookup">
    <!-- <p>write in: {{ isActive(BondLookupUIControlStage.WriteIn) | json }}</p> -->
    <!-- Test Toggle Switch -->
    <!-- <div class="cipx-form-form-group">
    <div class="cipx-form-label">Test Toggle Switches</div>
    <div class="flex flex-col gap-4">
      <div>
        <label>Primary Color Toggle:</label>
        <mat-slide-toggle color="primary">
          Test Primary Toggle
        </mat-slide-toggle>
      </div>
      <div>
        <label>Accent Color Toggle:</label>
        <mat-slide-toggle color="accent">
          Test Accent Toggle
        </mat-slide-toggle>
      </div>
      <div>
        <label>Warn Color Toggle:</label>
        <mat-slide-toggle color="warn">
          Test Warn Toggle
        </mat-slide-toggle>
      </div>
      <div>
        <label>Default Toggle (no color):</label>
        <mat-slide-toggle>
          Test Default Toggle
        </mat-slide-toggle>
      </div>
    </div>
  </div> -->

    <div class="cipx-form-section">
      <fieldset>
        <legend class="cipx-form-section-title">Which Surety Bond Do You Need?</legend>

        @if (isActive(BondLookupUIControlStage.State)) {
          <div class="cipx-form-form-group">
            <cipx-searchable-select
              [formGroup]="quoteRequestForm.controls.bondLookup"
              controlName="stateSelection"
              label="Which state do you need the bond for?"
              placeholder="Search states..."
              [options]="states"
              valueKey="value"
              labelKey="label"
              [multiple]="false"
              [useOptionAsValue]="true"
              [compact]="false"
              [deferErrorState]="true"
              [showValidationErrors]="showValidationErrors"
              [errorMessage]="
                showValidationErrors &&
                quoteRequestForm.controls.bondLookup.controls.stateSelection.hasError('required')
                  ? 'Please select a state'
                  : ''
              "
              (selectionChange)="onStateSelected($event)"></cipx-searchable-select>
          </div>
        }
        @if (isActive(BondLookupUIControlStage.BondFamily)) {
          <div class="cipx-form-form-group">
            @if (bondFamiliesLoading()) {
              <div class="flex flex-row items-center justify-center">
                <mat-spinner></mat-spinner>
              </div>
            } @else if (bondFamilies().length > 0) {
              <cipx-searchable-select
                [formGroup]="quoteRequestForm.controls.bondLookup"
                controlName="bondFamilySelection"
                label="What type of surety bond do you need?"
                placeholder="Search bond types..."
                [options]="bondFamilies()"
                valueKey="bond_family_id"
                labelKey="bond_family_label"
                [multiple]="false"
                [useOptionAsValue]="true"
                [compact]="false"
                [deferErrorState]="true"
                [showValidationErrors]="showValidationErrors"
                [errorMessage]="
                  showValidationErrors &&
                  quoteRequestForm.controls.bondLookup.controls.bondFamilySelection.hasError('required')
                    ? 'Please select a bond type'
                    : ''
                "
                (selectionChange)="onBondFamilySelected($event)"></cipx-searchable-select>
            }
          </div>
        }
        @if (isActive(BondLookupUIControlStage.StateBond)) {
          <div class="cipx-form-form-group">
            @if (stateBondsLoading()) {
              <div class="flex flex-row items-center justify-center">
                <mat-spinner></mat-spinner>
              </div>
            } @else if (stateBonds().length > 0) {
              <cipx-searchable-select
                [formGroup]="quoteRequestForm.controls.bondLookup"
                controlName="stateBondSelection"
                label="Which specific surety bond do you need?"
                placeholder="Search specific bonds..."
                [options]="stateBonds()"
                valueKey="state_bond_id"
                labelKey="surety_bond_label"
                [multiple]="false"
                [useOptionAsValue]="true"
                [compact]="false"
                [deferErrorState]="true"
                [showValidationErrors]="showValidationErrors"
                [errorMessage]="
                  showValidationErrors &&
                  quoteRequestForm.controls.bondLookup.controls.stateBondSelection.hasError('required')
                    ? 'Please select a specific bond'
                    : ''
                "
                (selectionChange)="onStateBondSelected($event)"></cipx-searchable-select>
            }
          </div>
          @if (pricingCalculatorConfigurationLoading()) {
            <div class="flex flex-row items-center justify-center">
              <mat-spinner></mat-spinner>
            </div>
          } @else if (
            isActive(BondLookupUIControlStage.Penalty) &&
            sectionHasQuestions('state_bond_option_selection', selectedStateBond()) &&
            additionalQuestionsControlsReady('state_bond_option_selection', selectedStateBond())
          ) {
            <cipx-quote-request-intake-form-question-set
              [quoteRequestForm]="quoteRequestForm"
              sectionName="state_bond_option_selection"
              [stateBond]="selectedStateBond()"></cipx-quote-request-intake-form-question-set>
          }
        }
        @if (isActive(BondLookupUIControlStage.WriteIn)) {
          <div class="cipx-form-form-group">
            <mat-form-field appearance="fill" hideRequiredMarker="true" subscriptSizing="dynamic">
              <mat-label>Type in bond name, type of license, permit or business activity</mat-label>
              <input type="text" matInput formControlName="bond_family_label" placeholder="Enter a bond type" />
              <mat-error *ngIf="quoteRequestForm.controls.bondLookup.controls.bond_family_label.hasError('required')">
                Please enter the bond name or type
              </mat-error>
              <mat-error
                *ngIf="quoteRequestForm.controls.bondLookup.controls.bond_family_label.hasError('emptyString')">
                Bond name cannot be empty or contain only spaces
              </mat-error>
            </mat-form-field>
          </div>
          <div class="cipx-form-form-group">
            <mat-form-field appearance="fill" hideRequiredMarker="true" subscriptSizing="dynamic">
              <mat-label>Who's requiring the bond?</mat-label>
              <textarea matInput formControlName="surety_bond_user_notes" placeholder="" rows="3"></textarea>
              <mat-hint>
                e.g. City of Miami Building Commission, Secretary of State, DMV, Department of Revenue etc.
              </mat-hint>
              <mat-error
                *ngIf="quoteRequestForm.controls.bondLookup.controls.surety_bond_user_notes.hasError('required')">
                Please specify who is requiring the bond
              </mat-error>
              <mat-error
                *ngIf="quoteRequestForm.controls.bondLookup.controls.surety_bond_user_notes.hasError('emptyString')">
                This field cannot be empty or contain only spaces
              </mat-error>
            </mat-form-field>
          </div>
        }
        @if (!pricingCalculatorConfigurationLoading() && isActive(BondLookupUIControlStage.Penalty)) {
          <div class="cipx-form-form-group">
            <mat-form-field appearance="fill" hideRequiredMarker="true" subscriptSizing="dynamic">
              <mat-label>Bond amount?</mat-label>
              <span matTextPrefix>$</span>
              <input
                matInput
                [errorStateMatcher]="bondAmountErrorStateMatcher"
                formControlName="bond_amount"
                type="text"
                placeholder="0"
                mask="separator.0"
                thousandSeparator=","
                [dropSpecialCharacters]="false"
                [allowNegativeNumbers]="false" />
              <mat-hint>Bond amount is also called penalty, penal sum, coverage or limit.</mat-hint>
              <mat-error *ngIf="bondAmountShowsError && quoteRequestForm.controls.bondLookup.controls.bond_amount.hasError('required')">
                Please enter a bond amount
              </mat-error>
              <mat-error *ngIf="bondAmountShowsError && quoteRequestForm.controls.bondLookup.controls.bond_amount.hasError('min')">
                Bond amount must be greater than 0
              </mat-error>
              <mat-error *ngIf="bondAmountShowsError && quoteRequestForm.controls.bondLookup.controls.bond_amount.hasError('pattern')">
                Please enter a valid number
              </mat-error>
            </mat-form-field>
          </div>

          @if (
            !isActive(BondLookupUIControlStage.PenaltyOptions) &&
            pricingCalculatorConfiguration()?.penalty?.penalty_input_type === 6
          ) {
            <div class="cipx-form-form-group text-right">
              <button mat-button color="primary" (click)="getPenaltyOptions()">
                Get Options
                <mat-icon svgIcon="heroicons_outline:chevron-right"></mat-icon>
              </button>
            </div>
          } @else if (isActive(BondLookupUIControlStage.PenaltyOptions)) {
            @if (penaltyOptions() !== null && penaltyOptions() !== undefined && penaltyOptions()?.length) {
              <div class="cipx-form-label">Quote Options</div>
              <div class="cipx-form-form-group">
                <mat-radio-group
                  aria-label="Select Bond Term"
                  formControlName="selectedPenaltyOption"
                  class="cipx-form-mat-radio-group-rounded"
                  (change)="selectPenaltyOptionRadio($event)">
                  @for (option of penaltyOptions(); track $index) {
                    <mat-radio-button
                      [value]="option"
                      class="cipx-full-width-radio"
                      [ngClass]="{
                        'cipx-full-width-radio-selected': option === selectedPenaltyOption(),
                      }">
                      <div class="cipx-full-width-radio-label">
                        <span>{{ option.term.years }}-Year Bond</span>
                        <span class="font-bold">
                          {{ option.price.amount | currency: 'USD' }}
                        </span>
                      </div>
                    </mat-radio-button>
                  }
                </mat-radio-group>
              </div>
            }
          }
        }
        @if (isActive(BondLookupUIControlStage.BondSelectionCompleted)) {
          <!-- Company Type -->
          <div class="cipx-form-form-group">
            <div class="cipx-form-label">What type of business?</div>
            <mat-radio-group
              (change)="onCompanyTypeIdChanged($event)"
              formControlName="company_type_id"
              class="cipx-form-mat-radio-group cipx-business-type-radio-group">
              <mat-radio-button class="md:mx-2" *ngFor="let option of businessTypes()" [value]="option.value">
                {{ option.label }}
              </mat-radio-button>
            </mat-radio-group>
          </div>
        }
      </fieldset>
    </div>
    <!-- @if(isActive(BondLookupUIControlStage.BondSelectionCompleted)) {
  <div class="cipx-form-form-group text-right">
    <button mat-flat-button color="primary" (click)="stageComplete()">
      Next
      <mat-icon svgIcon="heroicons_outline:chevron-right"></mat-icon>
    </button>
  </div>
  } -->
  </form>
}

<!-- <p>{{ pricingCalculatorConfiguration() | json }}</p> -->
